import { NavLink } from "react-router-dom";

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const navItems = [
  { to: "/", label: "Home", end: true, enabled: true },
  { to: "/tenants", label: "Tenants", enabled: false },
  { to: "/deployments", label: "Deployments", enabled: false },
  { to: "/runtime", label: "Runtime", enabled: false },
  { to: "/services", label: "Services", enabled: false },
  { to: "/billing", label: "Billing", enabled: false },
  { to: "/observability", label: "Observability", enabled: false },
  { to: "/global-intelligence", label: "Global Intelligence", enabled: false },
];

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  return (
    <aside className={`sidebar ${isOpen ? "is-open" : ""}`} aria-label="Operations navigation">
      <p className="sidebar__label">Platform</p>
      <nav className="sidebar__nav">
        {navItems.map((item) =>
          item.enabled ? (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => `sidebar__link${isActive ? " is-active" : ""}`}
              onClick={onClose}
            >
              {item.label}
            </NavLink>
          ) : (
            <span key={item.to} className="sidebar__link is-disabled" title="Coming soon">
              {item.label}
            </span>
          ),
        )}
      </nav>
    </aside>
  );
}
